const name = 'Sequence';
const properties = {
    groups: ['animation'],
    schema: {
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        animations: {
            type: 'array',
        },
        repeat: {
            type: 'integer',
            min: -1,
        },
        repeatDelay: {
            type: 'number',
            min: 0,
        },
        yoyo: {
            type: 'boolean',
        },
    },
};
/**
 * Sequence animations
 */
function animate(kit, elements, sequenceDelay = {}, { animations, ...params } = {}) {
    const sequence = kit.sequence({ delay: sequenceDelay, ...params });
    animations.forEach((def) => {
        const { name: animationName, duration, delay, offset, from = {}, to = {}, ease, } = def;
        sequence.add(kit.animate(animationName, elements, duration, delay, {
            from,
            to,
            ease,
        }), offset);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=sequence.js.map